import { render } from "./NcrmMitpResolveUnmatchedDialog.vue?vue&type=template&id=0d480df5&scoped=true"
import script from "./NcrmMitpResolveUnmatchedDialog.vue?vue&type=script&lang=js"
export * from "./NcrmMitpResolveUnmatchedDialog.vue?vue&type=script&lang=js"

import "./NcrmMitpResolveUnmatchedDialog.vue?vue&type=style&index=0&id=0d480df5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d480df5"]])

export default __exports__